import React from 'react';
import HeroSection from './herosection';
import First from './first';
import ThirdSection from './third';
import Second from './second';
//import ResumePage from './four';
import ProfessionalSummary from './five';
import AwsCertificate from './cert_aws';
import TabComponent from '../pages/skills';
import AboutMe from '../pages/about';

function Home() {

  return (
    <div>
      <HeroSection/>
      <First/>
      {/* <ResumePage/> */}
      <ProfessionalSummary/>
      <TabComponent/>
      <AwsCertificate/>
      <Second/>
      <ThirdSection/>
      <AboutMe/>


    </div>

  )
}

export default Home;
